export const getAuth = getState => ({
  headers: {
    authorization: `Bearer ${getState().auth.token}`,
  },
});
